/**
 * The answer to every denial.
 *
 * Authority: bead scope-njw; PRD §4.2.
 *
 * This is what a wrong role, a wrong plane and a wrong URL all render. That is
 * the point: three different reasons must not be three distinguishable pages,
 * or the page becomes an oracle for the shape of the staff tree.
 */
import { t } from '../../shell/i18n.ts'

export default function NotFound() {
  return (
    <article className="not-found">
      <h1>{t('notFound.heading')}</h1>
      <p>{t('notFound.body')}</p>
      <a href="/">{t('notFound.home')}</a>
    </article>
  )
}
